/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { SignatureProgressDto } from './SignatureProgressDto';
import {
    SignatureProgressDtoFromJSON,
    SignatureProgressDtoFromJSONTyped,
    SignatureProgressDtoToJSON,
    SignatureProgressDtoToJSONTyped,
} from './SignatureProgressDto';
import type { FormElementSectionDto } from './FormElementSectionDto';
import {
    FormElementSectionDtoFromJSON,
    FormElementSectionDtoFromJSONTyped,
    FormElementSectionDtoToJSON,
    FormElementSectionDtoToJSONTyped,
} from './FormElementSectionDto';
import type { WorksCouncilTypeDto } from './WorksCouncilTypeDto';
import {
    WorksCouncilTypeDtoFromJSON,
    WorksCouncilTypeDtoFromJSONTyped,
    WorksCouncilTypeDtoToJSON,
    WorksCouncilTypeDtoToJSONTyped,
} from './WorksCouncilTypeDto';
import type { ApplicationFormStatus } from './ApplicationFormStatus';
import {
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusFromJSONTyped,
    ApplicationFormStatusToJSON,
    ApplicationFormStatusToJSONTyped,
} from './ApplicationFormStatus';

/**
 * 
 * @export
 * @interface ApplicationFormDto
 */
export interface ApplicationFormDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormDto
     */
    name: string;
    /**
     * 
     * @type {Array<FormElementSectionDto>}
     * @memberof ApplicationFormDto
     */
    formElementSections: Array<FormElementSectionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormDto
     */
    isTemplate: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormDto
     */
    organizationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormDto
     */
    organizationName?: string | null;
    /**
     * 
     * @type {WorksCouncilTypeDto}
     * @memberof ApplicationFormDto
     */
    worksCouncilType?: WorksCouncilTypeDto | null;
    /**
     * Keycloak group path this form is scoped to — the Betrieb path for BETRIEBSRAT, or the fixed /Gesamtbetriebsrat or /Konzernbetriebsrat path for GESAMTBETRIEBSRAT/KONZERNBETRIEBSRAT
     * @type {string}
     * @memberof ApplicationFormDto
     */
    worksCouncilGroupPath?: string | null;
    /**
     * 
     * @type {UserDto}
     * @memberof ApplicationFormDto
     */
    createdBy?: UserDto | null;
    /**
     * 
     * @type {UserDto}
     * @memberof ApplicationFormDto
     */
    lastModifiedBy?: UserDto | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationFormDto
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationFormDto
     */
    modifiedAt?: Date | null;
    /**
     * 
     * @type {ApplicationFormStatus}
     * @memberof ApplicationFormDto
     */
    status?: ApplicationFormStatus | null;
    /**
     * Total number of comments associated with this application form.
     * @type {number}
     * @memberof ApplicationFormDto
     */
    readonly commentCount?: number | null;
    /**
     * Temporary file IDs to associate atomically on creation (write-only, ignored on read)
     * @type {Array<string>}
     * @memberof ApplicationFormDto
     */
    fileIds?: Array<string> | null;
    /**
     * 
     * @type {SignatureProgressDto}
     * @memberof ApplicationFormDto
     */
    signatureProgress?: SignatureProgressDto | null;
    /**
     * Version number of the latest version (populated in list views)
     * @type {number}
     * @memberof ApplicationFormDto
     */
    readonly latestVersionNumber?: number | null;
    /**
     * Scheduled review date for this application form (Wiedervorlage)
     * @type {Date}
     * @memberof ApplicationFormDto
     */
    reviewDate?: Date | null;
    /**
     * Whether a review notification has already been sent
     * @type {boolean}
     * @memberof ApplicationFormDto
     */
    readonly reviewNotificationSent?: boolean | null;
    /**
     * Published version of a template form (isTemplate=true).
     * @type {number}
     * @memberof ApplicationFormDto
     */
    templateVersion?: number | null;
    /**
     * ID of the template this form was created from.
     * @type {string}
     * @memberof ApplicationFormDto
     */
    sourceTemplateId?: string | null;
    /**
     * Template version this form currently reflects (resolved server-side).
     * @type {number}
     * @memberof ApplicationFormDto
     */
    readonly sourceTemplateVersion?: number | null;
}



/**
 * Check if a given object implements the ApplicationFormDto interface.
 */
export function instanceOfApplicationFormDto(value: object): value is ApplicationFormDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('formElementSections' in value) || value['formElementSections'] === undefined) return false;
    if (!('isTemplate' in value) || value['isTemplate'] === undefined) return false;
    return true;
}

export function ApplicationFormDtoFromJSON(json: any): ApplicationFormDto {
    return ApplicationFormDtoFromJSONTyped(json, false);
}

export function ApplicationFormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'formElementSections': ((json['formElementSections'] as Array<any>).map(FormElementSectionDtoFromJSON)),
        'isTemplate': json['isTemplate'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'worksCouncilType': json['worksCouncilType'] == null ? undefined : WorksCouncilTypeDtoFromJSON(json['worksCouncilType']),
        'worksCouncilGroupPath': json['worksCouncilGroupPath'] == null ? undefined : json['worksCouncilGroupPath'],
        'createdBy': json['createdBy'] == null ? undefined : UserDtoFromJSON(json['createdBy']),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : UserDtoFromJSON(json['lastModifiedBy']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'status': json['status'] == null ? undefined : ApplicationFormStatusFromJSON(json['status']),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'signatureProgress': json['signatureProgress'] == null ? undefined : SignatureProgressDtoFromJSON(json['signatureProgress']),
        'latestVersionNumber': json['latestVersionNumber'] == null ? undefined : json['latestVersionNumber'],
        'reviewDate': json['reviewDate'] == null ? undefined : (new Date(json['reviewDate'])),
        'reviewNotificationSent': json['reviewNotificationSent'] == null ? undefined : json['reviewNotificationSent'],
        'templateVersion': json['templateVersion'] == null ? undefined : json['templateVersion'],
        'sourceTemplateId': json['sourceTemplateId'] == null ? undefined : json['sourceTemplateId'],
        'sourceTemplateVersion': json['sourceTemplateVersion'] == null ? undefined : json['sourceTemplateVersion'],
    };
}

export function ApplicationFormDtoToJSON(json: any): ApplicationFormDto {
    return ApplicationFormDtoToJSONTyped(json, false);
}

export function ApplicationFormDtoToJSONTyped(value?: Omit<ApplicationFormDto, 'commentCount'|'latestVersionNumber'|'reviewNotificationSent'|'sourceTemplateVersion'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'formElementSections': ((value['formElementSections'] as Array<any>).map(FormElementSectionDtoToJSON)),
        'isTemplate': value['isTemplate'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'worksCouncilType': WorksCouncilTypeDtoToJSON(value['worksCouncilType']),
        'worksCouncilGroupPath': value['worksCouncilGroupPath'],
        'createdBy': UserDtoToJSON(value['createdBy']),
        'lastModifiedBy': UserDtoToJSON(value['lastModifiedBy']),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'modifiedAt': value['modifiedAt'] == null ? undefined : ((value['modifiedAt'] as any).toISOString()),
        'status': ApplicationFormStatusToJSON(value['status']),
        'fileIds': value['fileIds'],
        'signatureProgress': SignatureProgressDtoToJSON(value['signatureProgress']),
        'reviewDate': value['reviewDate'] == null ? undefined : ((value['reviewDate'] as any).toISOString().substring(0,10)),
        'templateVersion': value['templateVersion'],
        'sourceTemplateId': value['sourceTemplateId'],
    };
}

